import { RadioPropertiesType } from "@website/ui-old/radio/radio.types";
import pick from "lodash-es/pick";

/**
 * @deprecated please use @website/ui instead
 */
export const useRadio = (properties: RadioPropertiesType) => ({
  inputProps: {
    ...pick(
      properties,
      "autoFocus",
      "disabled",
      "checked",
      "name",
      "onChange",
      "readOnly",
      "value"
    ),
    type: "radio"
  }
});
